<div class="project-detail">
  <header class="project-detail__header">
    <div class="project-detail__header-text">
      <div class="project-detail__title-row">
        <h1 class="project-detail__title">{{ selectedItem.title }}</h1>
      </div>
      @if (selectedItem.description) {
        <p class="project-detail__description">{{ selectedItem.description }}</p>
      }
    </div>
    <button
      *allowedRole="'admin'"
      mat-stroked-button
      color="primary"
      type="button"
      class="project-detail__edit"
      (click)="openEditModal()"
    >
      Edit project
    </button>
  </header>

  <app-panel-tabs
    class="project-detail__tabs"
    [tabs]="tabLabels"
    [(active)]="activeTabLabel"
    (activeChange)="onTabLabelChange($event)"
  />

  <div class="project-detail__body">
    @if (isTabVisible(allowedTabs.BOTS)) {
      <app-project-bots [selectedProject]="selectedItem" />
    }
    @if (isTabVisible(allowedTabs.SOURCES)) {
      <app-project-sources [selectedProject]="selectedItem" />
    }
    @if (isTabVisible(allowedTabs.USERS)) {
      <app-project-users [selectedProject]="selectedItem" />
    }
  </div>
</div>
